export default __webpack_public_path__ + "static/media/slide3.c8401279.png";